import { createFileRoute } from "@tanstack/react-router";
import { ExpeditionDetailPage } from "~/pages/expeditions/ExpeditionDetailPage";
export const Route = createFileRoute("/_authenticated/expeditions/$expeditionSlug")({
  component: ExpeditionDetailPage,
});
